// extracted by mini-css-extract-plugin
export default {"community":"Bookmarks_community__euJ60","classification":"Bookmarks_classification__Sw8UI","joinCommunity":"Bookmarks_joinCommunity__iwh6i"};